import { useCallback, useContext } from 'react';

import { GlobalsContext } from '@vestico/shared';
import '@vestico/shared/src/layouts/globalWrapper.scss';

import { ContentGlobalsContext } from '../../WidgetEventsManager';
import CarouselModal from '../carousel/modal/CarouselModal';
import { ContentInteractionContext, ContentProductContext, ContentResponsesContext } from './ContentDisplayContext';

interface ContentDisplayCarouselLoaderProps {
  initialResponseIndex?: number;
  entryID: string;
}

export const ContentDisplayCarouselLoader = ({ initialResponseIndex, entryID }: ContentDisplayCarouselLoaderProps) => {
  const {
    responses,
    selectedResponse,
    anyResponseHasMatchInfo,
    anyResponseHasMatch,
    onSelectedResponse,
    activeMatchingType,
    defaultMatchingType,
    onActiveMatchingTypeChange,
    hasContentMatchAvailable,
    hasSizeRecAvailable,
    sizeRecommendation,
  } = useContext(ContentResponsesContext);
  const { contentIsOpen, setContentOpen } = useContext(ContentGlobalsContext);
  const { onProductLinkClick } = useContext(ContentInteractionContext);
  const { products } = useContext(ContentProductContext);

  const onCarouselOpen = useCallback((open: boolean) => setContentOpen(open, entryID), [entryID, setContentOpen]);
  const { stylesConfig } = useContext(GlobalsContext);

  return (
    <CarouselModal
      initialResponseIndex={initialResponseIndex}
      responses={responses}
      selectedResponse={selectedResponse}
      onSelectedReponse={onSelectedResponse}
      anyResponseHasMatchInfo={anyResponseHasMatchInfo}
      anyResponseHasMatch={anyResponseHasMatch}
      carouselIsOpen={contentIsOpen}
      setCarouselOpen={onCarouselOpen}
      products={products}
      onProductLinkClick={onProductLinkClick}
      activeMatchingType={activeMatchingType}
      defaultMatchingType={defaultMatchingType}
      onActiveMatchingTypeChange={onActiveMatchingTypeChange}
      hasContentMatchAvailable={hasContentMatchAvailable}
      hasSizeRecAvailable={hasSizeRecAvailable}
      sizeRecommendation={sizeRecommendation}
      hideContentInfoCTAContentCarousel={stylesConfig.stylesConfig.hideContentInfoCTAContentCarousel}
    />
  );
};
